import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProjectId } from 'api/models';
import { ShiftTasksPayload } from 'api/project';
import { Modal } from 'components/atoms/modal';
import { RearrangeTree } from './tree';
import { Conflict } from './types';

interface Props {
  visible: boolean;
  onClose: () => void;
  currentTaskId: number;
  projectId: ProjectId;
  setActions: React.Dispatch<React.SetStateAction<ShiftTasksPayload>>;
  actions: ShiftTasksPayload;
  loading: boolean;
  rearrangeTasks: (updatedActions?: ShiftTasksPayload) => void;
  next: () => void;
  conflicts: Conflict[];
  setConflicts: React.Dispatch<React.SetStateAction<Conflict[]>>;
}

export const RearrangeTasks: FC<Props> = ({
  currentTaskId,
  visible,
  onClose,
  projectId,
  actions,
  setActions,
  loading,
  rearrangeTasks,
  next,
  conflicts,
  setConflicts,
}) => {
  const [haveConflicts, setHaveConflicts] = useState<boolean>(false);

  return (
    <Modal
      visible={visible}
      title={<FormattedMessage id="templates.rearrange_tasks.title" />}
      onCancel={onClose}
      afterClose={() =>
        setActions({
          updatedPhases: [],
          updatedTasks: [],
        })
      }
      onOk={() => {
        return haveConflicts ? next() : rearrangeTasks(actions);
      }}
      okText={
        haveConflicts ? (
          <FormattedMessage id="next" />
        ) : (
          <FormattedMessage id="done" />
        )
      }
      destroyOnClose
      maskClosable={false}
      confirmLoading={loading}
    >
      <RearrangeTree
        currentTaskId={currentTaskId}
        projectId={projectId}
        setActions={setActions}
        actions={actions}
        conflicts={conflicts}
        setConflicts={setConflicts}
        setHaveConflicts={setHaveConflicts}
      />
    </Modal>
  );
};
